import api from "./axiosInstance";

export interface Price {
  id: number;
  numberOfClasses: number;
  specialType: string | null;
  amount: number;
  currency: string;
  isAdminOnly: boolean;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}

export interface CreatePaymentRequest {
  attendeeId: number;
  priceId: number;
}

export interface CreatePaymentResponse {
  transactionId: string;
  sessionId: string;
  paymentUrl: string;
  amount: number;
  numberOfClasses: number;
  status: string;
}

// Get available pricing options
export const fetchPaymentPricingApi = async (): Promise<{ data: Price[] }> =>
  api.get("/api/payments/pricing");

// Create a new Stripe payment
export const createStripePaymentApi = async (
  request: CreatePaymentRequest
): Promise<{ data: CreatePaymentResponse }> =>
  api.post("/api/payments/create", request);

// Get payment status
export const getPaymentStatusApi = async (transactionId: string) =>
  api.get(`/api/payments/status/${transactionId}`);

// Get suitable prices for an attendee based on their enrolled classes
export const getSuitablePricesForAttendeeApi = async (data: {
  attendeeId: number;
  enrolledClassIds: number[];
}): Promise<{ data: Price[] }> =>
  api.post("/admin/prices/suitable-for-attendee", data);
